import { Moment } from 'moment';
import Tag from '@/shared/models/Tag';
import { UserId } from '@/shared/models/User';
import AbstractTask from './AbstractTask';

export interface DossierStackItemId {__dossierStackItemId: number;}

export interface DossierStackItemData {
  description: string;
  deadline: Moment | null;
}

export default class DossierStackItem extends AbstractTask {
  id!: DossierStackItemId;
  deadline: Moment | null = null;
  tags: Array<Tag> = [];
  createdById: UserId | null = null;

  update(data: DossierStackItemData): void {
    this.description = data.description;
    this.deadline = data.deadline;
  }
}